import _isNull from "lodash/isNull";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
export var formatShortText = function formatShortText(val, textLength) {
  if (_isNull(val) || val === '' || val === undefined) return '';
  var formatedText = val.replace(/(<([^>]+)>)/gi, '');
  var textLenghtVal = textLength !== null && textLength !== void 0 ? textLength : 200;
  return formatedText.length > textLenghtVal ? "".concat(formatedText.substring(0, textLenghtVal), "...") : formatedText;
};